import React, { useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Sidebar from "../components/sidebar/Sidebar";
import Dashboard from "../screens/dashboard";
import { Context } from "..";
import { RouteElement } from "./RouteElement";
import Profile from "../screens/Profile";

const RouterMain = () => {

  const { store } = useContext(Context)

  const [userRoutes, setUserRoutes] = useState([])

  useEffect(() => {
    if (store?.user?.role) {
      setUserRoutes(JSON.parse(JSON.stringify(store?.user?.role)))
    }
  }, [store.user])

  const RenderListRouter: any = (itemList: any, parentPath: string) => {
    const RouteList = [
      <Route key={0} path={`/`} element={<Dashboard />} />,
      <Route key={1} path={`/profile`} element={<Profile />} />
    ];

    for (let i = 0; i < itemList.length; i++) {
      const key = `${parentPath}${itemList[i].path}${Math.random() * (3 - 100) + 100
        }`.replace("/", "-");
      RouteList.push(
        <Route
          key={key}
          path={`${parentPath}/${itemList[i].path}`}
          element={RouteElement[itemList[i].element]}
        />
      );

      if (itemList[i].children && itemList[i].children.length > 0) {
        const childParenPath = `${parentPath}/${itemList[i].path}`;
        RouteList.push(RenderListRouter(itemList[i].children, childParenPath));
      }
    }
    return RouteList;
  };

  return (
    <React.Fragment>
      <Sidebar />
      <main className="main">
        <div id="mainBody" className="mainBody">
          <Routes>{RenderListRouter(userRoutes, "/admin")}</Routes>

        </div>
      </main>
    </React.Fragment>
  );
};

export default RouterMain;
